module.exports = __webpack_public_path__ + "static/img/5.735066ba.png";